import React from 'react';

interface IcoBanknotesProps {
    size?: number;
}

export const IcoBanknotes: React.FC<IcoBanknotesProps> = ({ size = 32 }) => {
    const wrapperStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: `${size}px`,
        height: `${size}px`,
    };

    return (
        <div style={wrapperStyle}>
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 32 32">
                <g fill="none">
                    <path
                        fill="#F1F1F1"
                        d="M27.264 11.732H4.736c-1.556 0-2.816 1.273-2.816 2.845v11.378c0 1.572 1.26 2.845 2.816 2.845h22.528c1.556 0 2.816-1.273 2.816-2.845V14.577c0-1.572-1.26-2.845-2.816-2.845zm-21.462 0 18.816-4.2c.331-.074.66-.076.978-.033l-1.573-2.842a2.802 2.802 0 0 0-3.833-1.095l-14.459 8.17h.07z"
                    />
                    <ellipse cx="16" cy="20.266" fill="#605F68" rx="4.928" ry="5.689" />
                    <ellipse cx="25.856" cy="20.266" fill="#605F68" rx="1.408" ry="1.422" />
                    <ellipse cx="6.144" cy="20.266" fill="#605F68" rx="1.408" ry="1.422" />
                    <path
                        fill="#B8B8B8"
                        d="M27.264 11.732c.44 0 .85.11 1.22.292l-.509-2.327c-.335-1.535-1.839-2.504-3.357-2.164L5.802 11.732h21.462z"
                    />
                </g>
            </svg>
        </div>
    );
};
